(function () {
  // Mobile menu
  var toggle = document.querySelector(".menu-toggle");
  var nav = document.getElementById("main-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  // Product gallery: clicking a thumbnail shows it as the main image
  var mainImage = document.querySelector("[data-main-image]");
  var thumbs = document.querySelectorAll("[data-thumb]");
  if (mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        mainImage.src = thumb.getAttribute("data-thumb");
        mainImage.alt = thumb.getAttribute("data-alt");
        thumbs.forEach(function (t) {
          t.setAttribute("aria-pressed", t === thumb ? "true" : "false");
        });
      });
    });
  }

  // Quantity stepper
  document.querySelectorAll("[data-stepper]").forEach(function (stepper) {
    var input = stepper.querySelector("[data-qty-input]");
    var value = stepper.querySelector("[data-qty-value]");
    var minus = stepper.querySelector('[data-step="-1"]');
    var plus = stepper.querySelector('[data-step="1"]');
    var max = parseInt(stepper.getAttribute("data-max"), 10) || 99;
    function set(qty) {
      qty = Math.min(Math.max(qty, 1), max);
      input.value = qty;
      value.textContent = qty;
      minus.disabled = qty <= 1;
      plus.disabled = qty >= max;
    }
    minus.addEventListener("click", function () { set(parseInt(input.value, 10) - 1); });
    plus.addEventListener("click", function () { set(parseInt(input.value, 10) + 1); });
  });

  // Collection sorting
  var sort = document.querySelector("[data-sort]");
  if (sort) {
    sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    });
  }
})();
